import { gql, apiRequest } from "./api";

interface GetSimReportsInput {
    uuid: String;
    token: String;
    organization_id: number | string | undefined;
    days: Number | undefined;
    date_from: String | undefined;
    date_to: String | undefined;
}

interface GetSimReportsExportInput {
    uuid: String;
    token: String;
    organization_id: number | string | undefined;
    days: Number | undefined;
    date_from: String | undefined;
    date_to: String | undefined;
    report_name: String;
}

export const GetAcademyReports = async({
    uuid, token, organization_id, days, date_from, date_to
}: GetSimReportsInput) => {

    const response = await gql({
        query: 
            `mutation GetAcademyReports {
                getAcademyReports(
                    getAcademyReportsInput: {
                        token: "${token}"
                        uuid: "${uuid}"
                        organization_id: ${organization_id}
                        date_from: "${date_from}"
                        date_to: "${date_to}"
                        days: ${days}
                    }
                ) {
                    chapters_finished
                    quizzes_taken
                    correct
                    incorrect
                    quiz_correct_rate
                    quiz_incorrect_rate
                    quiz_taken_rate
                }
            }
            `,
            returnFunc: 'getAcademyReports'
    })

    return response

}


export const GetSimReports = async({
    uuid, token, organization_id, days, date_from, date_to
}: GetSimReportsInput) => {

    const response = await gql({
        query: 
            `mutation GetSimulationReports {
                getSimulationReports(
                    getSimulationReportsInput: {
                        token: "${token}"
                        uuid: "${uuid}"
                        organization_id: ${organization_id}
                        date_from: "${date_from}"
                        date_to: "${date_to}"
                        days: ${days}
                    }
                ) {
                    sent
                    clicked
                    reported
                    ignored
                    click_rate
                    ignore_rate
                    failure_rate
                    average_reporting_time
                }
            }
            `,
            returnFunc: 'getSimulationReports'
    })

    return response

}


export const GetUserSimReports = async({
    uuid, token, organization_id, days, date_from, date_to
}: GetSimReportsInput) => {

    const response = await gql({
        query: 
            `mutation GetUserSimReports {
                getUsersSimReports(
                    getUsersSimReportsInput: {
                        token: "${token}"
                        uuid: "${uuid}"
                        organization_id: ${organization_id}
                        date_from: "${date_from}"
                        date_to: "${date_to}"
                        days: ${days}
                    }
                ) {
                    report {
                        firstname
                        lastname
                        reported_count
                        clicked_count
                        ignored_count
                        uuid
                        academy_chapters_completed
                        quizes_taken
                        questions_correct
                        questions_incorrect
                    }
                }
            }`,
        returnFunc: 'getUsersSimReports'
    })

    return response;
}


export const GetReportExport = async({
    uuid, token, organization_id, days, date_from, date_to, report_name
}: GetSimReportsExportInput) => {

    const blob = await apiRequest<Blob>({
        url: `/report/download/${organization_id}/`,
        method: 'GET',
        params: { days: days, date_from: date_from, date_to: date_to },
        responseType: 'blob',
    });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = report_name.toString();

  document.body.appendChild(link);
  
  link.click();
  link.remove();

}